import { EventBase } from "@vp/models";

export interface PatientMessageNotification {
  caseId: string;
  message: string;
  messageSentBy: string;
  messageDateTime: string;
}

export class MessageToPatientEvent extends EventBase<PatientMessageNotification> {
  constructor(patientMessageNotifcation: PatientMessageNotification) {
    super();
    this.args = patientMessageNotifcation;
  }
}
